export default "__VITE_ASSET__DVV3Fu0R__"